import React, { useState } from "react";
import { createPortal } from "react-dom";
import { IoIosClose, IoIosWifi } from "react-icons/io";

const WifiModal = ({ statusFlow, setOverlayVisible, setIsWifiModalOpen }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(
        statusFlow.wifiDetails.wifiInstructions
      );
      setCopied(true);
      setTimeout(() => setCopied(false), 5000);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };
  const [showWifiDetails, setShowWifiDetails] = useState(false);
  const handleDetails = () => {
    if (
      statusFlow &&
      statusFlow.wifiDetailsEnabled &&
      statusFlow.clickableLinksOrButtonsEnabled
    ) {
      // open new tab
      window.open(`${statusFlow.clickableLinksOrButtons[0]}`, "_blank");
    } else {
      setShowWifiDetails(true);
    }
  };
  // console.log(statusFlow);
  return (
    <>
      <div className="relative isolate shadow m-5">
        <div className="bg-white sm:rounded-lg rounded-xl inline-flex items-center justify-between gap-x-1 text-sm font-semibold leading-6 w-full p-3">
          <div className="flex flex-row gap-2 items-center">
            Wi-Fi
            <span>
              <IoIosWifi className="h-4 w-4" />
            </span>
          </div>
          <button
            className="text-indigo-600 rounded-md hover:bg-indigo-50 text-[14px]"
            onClick={() => {
              setOverlayVisible(true);
              setIsWifiModalOpen(true);
              handleDetails();
            }}
          >
            Tap to Connect
          </button>
        </div>
      </div>

      {/* Render Modal using Portal */}
      {showWifiDetails &&
        createPortal(
          <>
            {/* Black Overlay */}
            <div
              className="fixed inset-0 bg-black bg-opacity-50 z-[9999]"
              onClick={() => {
                setShowWifiDetails(false);
                setIsWifiModalOpen(false);
                setOverlayVisible(false);
              }}
            ></div>

            {/* Modal Content */}
            <div className="fixed bottom-0 left-0 w-full bg-white p-4 shadow-lg rounded-t-lg z-[99999] h-52">
              <div className="flex items-center justify-between">
                <div className="flex-1 text-lg text-black text-center">Wi-Fi Details</div>
                <button
                  onClick={() => {
                    setShowWifiDetails(false);
                    setOverlayVisible(false);
                    setIsWifiModalOpen(false);
                  }}
                >
                  <IoIosClose className="h-8 w-8" />
                </button>
              </div>

              {statusFlow.wifiDetailsEnabled && (
                <div className="flex flex-col items-start pb-4">
                  <div className="text-gray-500 text-base">Wi-Fi Name</div>
                  <div className="text-black text-base">{statusFlow.wifiDetails.wifiName}</div>
                </div>
              )}

              {statusFlow.wifiDetailsEnabled && (
                <div className="flex flex-col items-start pb-4">
                  <div className="text-gray-500 w-full text-base flex flex-row justify-between items-center">
                    <p>Wi-Fi Password</p>
                    {copied ? (
                      <p className="text-black text-sm">Copied</p>
                    ) : (
                      <button onClick={handleCopy} className="text-black">
                        Copy
                      </button>
                    )}
                  </div>
                  <div className="text-black text-base">{statusFlow.wifiDetails.wifiInstructions}</div>
                </div>
              )}
            </div>
          </>,
          document.body
        )}
    </>
  );
};

export default WifiModal;
